import axios from "@/plugins/axios.js"

const actions = {
  fetchCategories({ commit, state }, force = false) {
    if(!force && state.categories.length) return;
    return new Promise((resolve, reject) => {
      axios.get("/categories")
        .then((response) => {
          if(response.data.success){
              commit('SET_CATEGORIES', response.data.data)
            }
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCategory({ commit }, categoryId) {
    return new Promise((resolve, reject) => {
      axios.get(`/categories/${categoryId}/show`)
        .then((response) => {
          if(response.data.success){
              commit('SET_CATEGORY', response.data.data)
            }
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(payload.action, payload.formData)
      .then((response) => {
          if(response.data.success && payload.update){
            commit('SET_CATEGORY', response.data.data)
          }
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}

const getters = {
   
}


const mutations = {
  ADD_CATEGORY(state, category) {
    state.categories.unshift(category)
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  UPDATE_CATEGORY(state, category){
    Object.assign(state.category, category)
    if(state.categories.length){
      const dataIndex = state.categories.findIndex((o) => o.id == category.id);
      Object.assign(state.categories[dataIndex], category);
    }
  },
  DELETE_CATEGORY(state, categoryId) {
      const ItemIndex = state.categories.findIndex((item) => item.id == categoryId)
      state.categories.splice(ItemIndex, 1)
  },

  /************** FOR DESCRIPTION *****************/
  UPDATE_DESCRIPTION(state, description){
    state.category.description = description
  },
}

const state = {
  categories: [],
  category: {},
}


export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

